import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class Analytics extends BaseModel {
  constructor() {
    super(collection(db, 'analytics_metadata'))
  }
}
